<div class="an-tooltip">
  <ng-content></ng-content>

  <span class="an-tooltip__wrap" [ngStyle]="{'margin-left': tooltipMarginLeft, 'margin-bottom': tooltipMarginBottom,  'width': tooltipWith }"
    [style]="'--left-margin: ' + tooltipArrowMarginLeft">
    <h3 class="an-tooltip__title"> {{ tooltipTitle }} </h3>
    <p class="an-tooltip__content"> {{ tooltipContent }} </p>
  </span>
</div>